module.exports = __webpack_public_path__ + "img/sign-in-email.0f704c9f.svg";